import { globalHistory } from "@reach/router";

export enum TRACKING_ID {
  GoogleTagManagerWeb = 'GTM-TPDNKZHK',
}

export const IS_CHINA_SITE = globalHistory && globalHistory.location?.host === 'perpetua.com.cn';

export const TRACKING_LIBS = {
  GoogleTagManager: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://sgtm.perpetua.io/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${TRACKING_ID.GoogleTagManagerWeb}');`,
};

// Lead & P2+ MQL (5 * 2): demo, signup, Prism , AMC / BI (custom case)
export const PAID_SOCIAL = {
  lead: {
    Facebook: {
      noMQL: 'Lead',
      MQL: 'Lead P2+'
    },
    Linkedin: {
      noMQL: '12594972',
      MQL: '12594980',
    },
    Bing: {
      noMQL: 'Lead',
      MQL: 'Lead P2 Plus',
    }
  },
  leadCustom: { // reverse lead / P2+ logic, in use for for AMC / BI
    Facebook: {
      noMQL: 'Lead P2+',
      MQL: ''
    },
    Linkedin: {
      noMQL: '12594980',
      MQL: '',
    },
    Bing: {
      noMQL: 'Lead P2 Plus',
      MQL: '',
    }
  },
  downloadables: {
    Facebook: {
      noMQL: 'Content Download',
      MQL: 'Content Download P2+'
    },
    Linkedin: {
      noMQL: '9173092',
      MQL: '15350236',
    },
    Bing: {
      noMQL: 'Content Download',
      MQL: 'Content Download P2 Plus',
    }
  },
  webinars: {
    Facebook: {
      noMQL: 'Webinar Registration',
      MQL: 'Webinar Registration P2+'
    },
    Linkedin: {
      noMQL: '2353825',
      MQL: '15350244',
    },
    Bing: {
      noMQL: 'Webinar Registration',
      MQL: 'Webinar Registration P2 Plus',
    }
  },
  newsletter: {
    Facebook: {
      noMQL: 'Newsletter Signup',
      MQL: ''
    },
    Linkedin: {
      noMQL: '14496570',
      MQL: '',
    },
    Bing: {
      noMQL: 'Newsletter Signup',
      MQL: '',
    }
  },
};

export const BOTS = [
  'datadogsynthetics',
  'googlebot',
  'headlesschrome',
  'bingbot',
  'slurp',
  'duckduckbot',
  'baiduspider',
  'yandexbot',
  'exabot',
  'facebot',
  'ia_achiver',
];

export enum ACTION {
  PageViewed = 'Page Viewed',
  CTAClicked = 'CTA Clicked',
  LinkClicked = 'Link Clicked',
  NaviClicked = 'Navi Clicked',
  FormSubmitted = 'Form Submitted',
  VideoPlayback = 'Video Playback',
}

export enum LABEL {
  BI = 'BI',
  AMC = 'AMC',
  Demo = 'Demo',
  Signin = 'Sign In',
  Signup = 'Get Started',
  Learn = 'Learn More',
  Prism = 'Prism',
  Webinar = 'Webinar',
  Affiliate = 'Affiliate',
  Newsletter = 'Newsletter',
  Benchmarker = 'Benchmarker',
  Downloadable = 'Downloadable',
  Chat = 'Chat With Us',
  Startup = 'Startup',
}

export enum FORM_TYPE {
  SignUp = 'Sign Up',
  WEBINAR = 'Webinar',
  RESOURCE = 'Resource',
  AFFILIATE = 'Affiliate', 
  DATA_CONSULT = 'Data Consult',
  PRISM = 'Prism',
}

export enum ONPAGE_SLOT {
  Hero = 'Hero',
  Midpage = 'Mid-page',
  Footer = 'Footer',
  Sidebar = 'Sidebar',
}

export enum UTM {
  campaign = 'utm_campaign',
  medium = 'utm_medium',
  source = 'utm_source',
  term = 'utm_term',
  content = 'utm_content',
  id = 'utm_id'
}

export enum platformID {
  gclid = 'gclid',
  fbclid = 'fbclid',
  li_fat_id = 'li_fat_id',
  campaignid = 'campaignid',
  adgroupid = 'adgroupid',
  keyword = 'keyword',
}
